export const withUseQuery = async <T>(apiCall: () => Promise<[T, boolean, string?]>): Promise<T> => {
  const [data, error, errorMessage] = await apiCall();
  if (error) throw Error(errorMessage ?? '');

  return data;
};
